import { DrawerPanel } from '@dmc/ui';
import { ReactElement } from 'react';
import SpeedLimitForm from './components/speed-limit-form/SpeedLimitForm';
import useLoadModelData from '@casops/components/layout/model-form/useLoadModelData';
import { ModelName } from '@casops/store/api';
import { useModelFormTitle } from '@casops/components/layout/model-form/useModelFormTitle';
import { useRenderKey } from '@casops/hooks/useRenderKey';
import { useGetGeofenceSpeedLimitQuery } from '@casops/store/apis/geofenceSpeedLimitsApi';

const modelName = ModelName.GeofenceSpeedLimit;

export function ManageGeofenceSpeedLimit(): ReactElement {
  const title = useModelFormTitle(modelName);

  const { isLoaded, item } = useLoadModelData({
    useModelQueryHook: useGetGeofenceSpeedLimitQuery,
  });

  // The renderKey must update whenever the item data changes to ensure the form is remounted and RHK and VDS stay in sync.
  const renderKey = useRenderKey(item ? item : 'create-form');

  return (
    <DrawerPanel isLoaded={isLoaded} header={title}>
      <SpeedLimitForm key={renderKey} item={item} />
    </DrawerPanel>
  );
}

export default ManageGeofenceSpeedLimit;
